import InterRegular from '@assets/fonts/Inter-Regular.woff2';
import InterMedium from '@assets/fonts/Inter-Medium.woff2';
import InterSemiBold from '@assets/fonts/Inter-SemiBold.woff2';
import InterBold from '@assets/fonts/Inter-Bold.woff2';
import InterExtraBold from '@assets/fonts/Inter-ExtraBold.woff2';

const InterFontRegular = `{
  font-family: 'Inter';
  font-style: 'normal';
  font-weight: 400;
  src: local('Inter-Regular'), 
    url(${InterRegular}) format('woff2');
}`;

const InterFontMedium = `{
  font-family: 'Inter';
  font-style: 'normal';
  font-weight: 500;
  src: local('Inter-Medium'), 
      url(${InterMedium}) format('woff2');
}`;

const InterFontSemiBold = `{
  font-family: 'Inter';
  font-style: 'normal';
  font-weight: 600;
  src: local('Inter-SemiBold'), 
      url(${InterSemiBold}) format('woff2');
}`;

const InterFontBold = `{
  font-family: 'Inter';
  font-style: 'normal';
  font-weight: 700;
  src: local('Inter-Bold'), 
        url(${InterBold}) format('woff2');
}`;

const InterFontExtraBold = `{
  font-family: 'Inter';
  font-style: 'normal';
  font-weight: 800;
  src: local('Inter-ExtraBold'), 
        url(${InterExtraBold}) format('woff2');
}`;

const fonts = [
  InterFontRegular,
  InterFontMedium,
  InterFontSemiBold,
  InterFontBold,
  InterFontExtraBold,
];

export default fonts;
